import React from 'react'
import {
  OptionWrapper,
  OptionWrapperProps,
} from 'src/editor/layout/sidebar/settings/option-wrapper'
import { TextArea, TextAreaProps } from 'src/editor/shared/ui-lib/text-area'

interface TextAreaControlProps
  extends Omit<TextAreaProps, 'onChange' | 'onReset'>,
    OptionWrapperProps {
  update: (value: string) => void
  wrapperProps?: OptionWrapperProps
}

export const TextAreaControl = ({
  wrapperProps,
  update,
  ...props
}: TextAreaControlProps) => {
  return (
    <OptionWrapper {...wrapperProps}>
      <TextArea onChange={update} {...props} />
    </OptionWrapper>
  )
}
